import { isExamFormRoutePath } from '../utils/examFormQuery.utils';

export type ExamFormAutoSaveFlushHandler = () => Promise<void>;

let activeFlushHandler: ExamFormAutoSaveFlushHandler | null = null;

/** Registered by FormRenderer on `/examform` while mounted. */
export function registerExamFormAutoSaveFlushHandler(
  handler: ExamFormAutoSaveFlushHandler | null,
): void {
  activeFlushHandler = handler;
}

/**
 * Persists pending exam-form edits before cross-portal silent logout clears storage.
 * No-op when not on `/examform` or when FormRenderer is not mounted.
 */
export async function flushExamFormAutoSaveBeforeCrossPortalLogout(): Promise<void> {
  if (!isExamFormRoutePath(window.location.pathname)) {
    return;
  }

  const handler = activeFlushHandler;
  if (!handler) {
    return;
  }

  try {
    await handler();
  } catch (error) {
    console.warn(
      '[examFormAutoSaveFlush] Failed to flush pending changes (continuing logout):',
      error,
    );
  }
}
